import React from "react";

const Info = (props) => {

    return (
        <div>
            <div className="row">
                <div className="col-xs-12">
                    <label className="label-primary">{props.titulo}</label>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12">
                    <label className="label-secondary">{props.descripcion}</label>
                </div>
            </div>
        </div>
    )
}

export default Info;